import '../scss/main.scss';
$(document).ready(function () {
  const $contentBox = $(".gray_box_section_box");
  const $readMoreBtn = $(".read_more");
  const maxHeight = 500; // 初期表示の高さ

  // 初期判定 - 高さが500pxを超えるかチェック
  $contentBox.each(function () {
    const $box = $(this);
    const $btn = $box.siblings(".read_more");

    if ($box.outerHeight() > maxHeight) {
    $box.css({
    "max-height": `${maxHeight}px`,
    "overflow": "hidden",
  });
  $btn.show();
  } else {
    $box.addClass("no-blur");
    $btn.hide();
    }
  });

  // 「もっと見る」ボタンのクリック時の動作
  $readMoreBtn.on("click", function () {
    const $box = $(this).siblings(".gray_box_section_box");
    $box.toggleClass("expanded");
    $box.toggleClass("no-blur");
    if ($box.hasClass("expanded")) {
      $(this).text("閉じる");
    } else {
      $(this).text("もっと見る");
    }
  });
});


// スムーススクロール
$('a[href*="#"]').on('click', function(event) {
  var isSamePage = location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
                   && location.hostname === this.hostname;

  if (isSamePage && this.hash) {
    event.preventDefault();

    var target = $(this.hash);
    if (target.length) {
      var offset = 150;
      var position = target.offset().top - offset;
      $('html, body').animate({ scrollTop: position }, 500, 'swing');
    }
  }
  if (window.location.hash) {
    var target = $(window.location.hash);
    if (target.length) {
      var offset = 150;
      var position = target.offset().top - offset;

      // ページ読み込み後にスムーススクロールを実行
      $('html, body').animate({ scrollTop: position }, 500, 'swing');
    }
  }
});

// そのほかのアニメーション
$(window).on('scroll', function() {
    $('.flip-in, .under-in, .roll-in').each(function() {
        var elementTop = $(this).offset().top;
        var viewportBottom = $(window).scrollTop() + $(window).height();

        // 要素が画面内に入ったら visible クラスを追加
        if (elementTop < viewportBottom - 50) {
            $(this).addClass('visible');
        }
    });
});